import { useEffect } from "react";

import { Box, ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import { useUser } from "@clerk/clerk-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router } from "react-router-dom";

import AuthStateListener from "./components/auth/AuthStateListener";
import { BotpressChat } from "./components/BotpressChat";
import DebugModeListener from "./components/DebugModeListener";
import { useDebugStore } from "./store/debugStore";

import Routings from "~/router/Routings";
import { identifyUserForScreenReplay, initScreenReplay } from "~/services/screen-replay-service";
import { theme } from "~/styles/theme";

initScreenReplay();
const queryClient = new QueryClient();

const App = () => {
  console.log("App.tsx - Rendering App");
  const user = useUser();
  const tallyRender = useDebugStore((state) => state.tallyRender);

  // Track render count for App component
  useEffect(() => {
    tallyRender("App");
  }, [tallyRender]);

  useEffect(() => {
    if (!user.isLoaded) return;

    if (user.isSignedIn) {
      identifyUserForScreenReplay(user.user?.emailAddresses[0].emailAddress);
    }
  }, [user.isSignedIn]);

  return (
    <QueryClientProvider client={queryClient}>
      <Box className="id--app">
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <ChakraProvider theme={theme} resetCSS={true}>
          <Router>
            <AuthStateListener />
            <DebugModeListener />
            <Routings />
            <BotpressChat />
          </Router>
        </ChakraProvider>
      </Box>
    </QueryClientProvider>
  );
};

export default App;
